<template>
    <div class="device-config">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>使用记录保存周期</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="margin-top: 1rem; padding: 1.5rem 1rem 1rem 1rem; background-color: white">
            <el-form ref="form">
                <el-form-item label="使用记录保存周期">
                    <el-col :span="4">
                        <el-input v-model="useinfoCycle" placeholder="使用记录保存周期" >
                            <template slot="append">天</template>
                        </el-input>
                    </el-col>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import settingsApi from "../../api/settings";

    export default {
        name: "DeviceConfig",
        data: function () {
            return {
                useinfoCycle: 0
            }
        },
        mounted: function() {
          this.getUckey();
        },
        methods: {
            getUckey: function () {
                settingsApi.getUseinfoCycle().then(res => this.useinfoCycle = res.useinfoCycle);
            },
            onSubmit: function () {
                settingsApi.updateUseinfoCycle(this.useinfoCycle).then(() => {
                    this.$message({
                        type: 'success',
                        message: '更新成功!'
                    });
                })
            }
        }
    }
</script>

<style scoped>

</style>
